var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 288,
    viewBox: "0 0 535 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 535,
    height: 288,
    fill: "#434343",
    style: {
      mixBlendMode: "darken"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.368 179.719L237.931 108.706L299.648 143.834L238.368 179.719Z",
    fill: "#971212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.73e05fc2f80891a83749d36a9c07ca0c.svg";
export { ForwardRef as ReactComponent };